module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#bundle",
      toString: function () {
        return this.url;
      }
    }